import React from 'react';
import { Route } from '../Routing/types';
import { BiometricSettingsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/biometric-settings/*',
    element: <BiometricSettingsPage descendantRoutes={descendantRoutes} />,
    private: true,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
